import React from "react";
import headerImage from "../../images/img7.jpg";
import Typewriter from "typewriter-effect";


const Header = () => {
  return (
    <div>
      <div className="tw-relative tw-overflow-hidden">
        <div className="tw-relative tw-w-full tw-h-[90vh] clip-path">
          <img
            src={headerImage}
            loading="lazy"
            className="tw-w-[100%] tw-h-full tw-object-cover"
          />

          <div className="overlay tw-absolute tw-top-0 tw-right-0 tw-z-1 tw-w-full tw-h-full tw-text-white tw-flex tw-justify-start tw-items-center">
            <div className="tw-container tw-flex tw-justify-start tw-mx-[80px] sm:tw-w-full -tw-mt-6">
              <div className="tw-flex tw-flex-col tw-items-center tw-gap-5 tw-w-[50%] sm:tw-w-full">
                <div
                  className="tw-text-3xl md:tw-text-2xl sm:tw-text-xl tw-font-bold"
                  data-aos="fade-left"
                  data-aos-duration="700"
                >
                  <h3>خدمة سوق السجانة</h3>
                </div>
                <div data-aos="fade-left" data-aos-duration="700">
                  <p className="tw-text-lg md:tw-text-md tw-p-2 sm:tw-p-1 tw-tracking-wider tw-leading-8 tw-text-center">
                  
                  <Typewriter 
                         options={{
                            autoStart : true , 
                            loop : true , 
                            delay : 60,
                            strings : ["منصة إخبارية تُعني بنشر وتحديث أسعار مواد البناء والتشييد بصورة راتبة ومستمرة بالإضافة للعديد من المقالات المكتوبة والمرئية عن مواضيع البناء والتشييد في السودان والاخطاء الشائعة فيما يخص البناء والتشييد وتقديم عروض الشراء من أفضل الشركات والحرفيين والموردين ."],
                         }}
                        />
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
